import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from '../../../types/referral/store';
import {
  fetchCianApiSiteV1GetUserDataByRequest,
  type TCianApiSiteV1GetUserDataByRequestResponse,
} from '../../../repositories/monolith-python/cian-api/site/v1/get-user-data-by-request';
import { setReferralUserPhoneNumber } from '../../../slices';

export const getPhoneNumberUser = createAsyncThunk<void, undefined, IThunkApi>('user/getUser', async (_, _thunkApi) => {
  const {
    dispatch,
    extra: { httpApi, logger },
  } = _thunkApi;

  try {
    const res = (await fetchCianApiSiteV1GetUserDataByRequest({
      httpApi,
    })) as TCianApiSiteV1GetUserDataByRequestResponse;

    if (res.statusCode === 200) {
      const {
        data: { user },
      } = res.response;

      if (user) {
        const { phones } = user;
        const { phone } = phones?.[0] || {};
        dispatch(setReferralUserPhoneNumber(phone));

        return;
      }
    }
  } catch (e) {
    logger.debug('Ошибка загрузки листинга рефералов', {
      message: e.message,
      domain: e.domain,
    });

    dispatch(setReferralUserPhoneNumber(undefined));

    return;
  }
});
